import React from 'react';
import { Form, Row, Col, DatePicker, TimePicker } from 'antd';
import moment from 'moment-timezone';
import { getMomentUserTimezoneWithFormat, getMomentUtcToUserTimezone } from 'modules/look';
const FormItem = Form.Item;

const SurveyDatePickerField = props => {
  const { margin, type,enabledisabledDate,required,format,showTime, ...rest } = props;
  const [val,setval] = React.useState(undefined)
React.useEffect(() => {
  if (props?.value){ 
  setval(getMomentUtcToUserTimezone(props.value))
  }
}, [props.value])  


  function handleChangeToUtc(value) {
    //Vals to be submitted to backend must be in utc
    if (typeof (props.onChange) === 'function') {
      setval(value)
      props.onChange(value ? moment.utc(value) : value)
      
    }
  }

  const tzAwareTimeFormat = () => {
    if (!val) {
      return ""
    }
    if (props.format !== undefined) {
      return `${getMomentUserTimezoneWithFormat(val, props.format)}`;
    }
    return `${getMomentUserTimezoneWithFormat(val, "HH:mm")}`;
  }

  return (
    <div style={{ marginBottom: margin ? '5vh' : '' ,maxWidth:"290px"}}>
      <Row className='survey-custon-datepicker' >
        <Col span={margin ? 14 : 24} style={{position:"relative"}}>
          <FormItem  required={required}{...rest}>
            {type === 'time' ? (
              <TimePicker className='generic-survey-date-picker-custom' style={{ width: '100%', height: '40px' }} {...props} onChange={handleChangeToUtc} format={tzAwareTimeFormat}/>
            ) :type === 'month' ?(
              <DatePicker  
              className='generic-survey-date-picker-custom'
              dropdownClassName = {'generic-survey-date-picker-date'}  
              format={'MMMM'}
               picker="month"
              //  disabledDate={current=>current.isBefore(moment().subtract(1,"day"))}
               style={{ width: '100%', height: '40px' }}
               onChange={handleChangeToUtc} />
            ):type === 'week' ?(
              <DatePicker  
              className='generic-survey-date-picker-custom'
              dropdownClassName = {'generic-survey-date-picker-date'}  
              // format={'MMMM'}
               picker="week"
              //  disabledDate={current=>current.isBefore(moment().subtract(1,"day"))}
               style={{ width: '100%', height: '40px' }}
               onChange={handleChangeToUtc} />
            ): (
              <DatePicker
                className='generic-survey-date-picker-custom'
                dropdownClassName = {'generic-survey-date-picker-date'}
                style={{ width: '100%', height: '40px' }}
                format={format||'DD/MM/YYYY'}
                showTime={showTime || false}
                // disabledDate={current=>current.isBefore(moment().subtract(1,"day"))}
                {...props}
                onChange={(e)=>{handleChangeToUtc(e)}}
              />
            )}
          </FormItem>
        </Col>
      </Row>
    </div>
  );
};

export default SurveyDatePickerField;
